// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_e5ba0dec","fontBold":"_806e661e","tab":"_3e7329f","tabItem":"_57942eaa","active":"_6a487104","collapsed":"_230759a7"};